const mensajes = {
    // DocumentoValorTotal
    'DocumentoValorTotal.Titulo': 'Document total',
};

export default mensajes;
